export const DOLLAR_SYMBOL = '$';

export const CURRENCY_STYLE_TO_OVERRIDE = 'symbol';

export const DOLLAR_SYMBOL_OVERRIDE = {
    MXN: 'MX',
    AUD: 'A',
    CAD: 'CA',
};
